interface AgencyClinicLike {
  id: string;
  clinic_key?: string | null;
  clinic_source?: string | null;
  /** EMR-375: clinic participates in Kinnser sync (every clinic is on Roger). */
  is_kinnser?: boolean;
  use_kinnser_wrm?: boolean;
}

/**
 * Whether this clinic participates in Kinnser/WellSky (EMR-375).
 *
 * ``is_kinnser`` is the source of truth. Deprecated ``clinic_source`` is
 * origin-only metadata until the column is dropped.
 */
export function clinicParticipatesInKinnser(
  clinic:
    | Pick<AgencyClinicLike, 'is_kinnser' | 'clinic_source'>
    | null
    | undefined
): boolean {
  if (!clinic) return false;
  return clinic.is_kinnser === true;
}

/**
 * Resolve the Kinnser clinic key for a clinic. Only Kinnser-participating clinics
 * have a WellSky clinic id; RogerEMR-only clinics also carry a clinic_key now
 * (sequence-assigned), so this returns null for them to keep native keys out of
 * Kinnser/RogerDoc API calls (patient match, task creation, onboarding, catalog).
 */
export function resolveClinicKeyFromAgencyClinicId(
  agencyClinics: AgencyClinicLike[],
  agencyClinicId: string | null | undefined
): string | null {
  if (!agencyClinicId) return null;

  const clinic = agencyClinics.find(c => c.id === agencyClinicId);
  if (!clinicParticipatesInKinnser(clinic)) return null;
  return clinic?.clinic_key ?? null;
}

export function isClinicWrmEnabled(
  agencyClinics: AgencyClinicLike[],
  agencyClinicId: string | null | undefined
): boolean {
  if (!agencyClinicId) return false;

  return (
    agencyClinics.find(clinic => clinic.id === agencyClinicId)
      ?.use_kinnser_wrm ?? false
  );
}
